<rask-map class="karta-container" [settings]="mapsettings">
    <rask-map-fastighet [hideButton]="false" [importEnabled]="false"></rask-map-fastighet>
    <rask-map-measure></rask-map-measure>
    <rask-map-fullscreen></rask-map-fullscreen>
    <rask-map-layers></rask-map-layers>
</rask-map>
